<div id="holding" class="bg">
  <div class="container">
    <div class="row justify-content-center align-items-center centerize">
      <div class="col-xl-6 col-md-8 col-sm-10">
        <div class="form-inner" *ngIf="token">
          <div class="logo">
            <img src="assets/img/kalem-logo2-png.png" class="kalemlogo" />
            <div class="baslik">Yeni Şifre Oluşturma</div>
          </div>
          <small [hidden]="successStatus"
            >Yeni şifre oluşturmak için aşağıdaki bilgileri doldurarak Şifre
            Oluştur'a tıklayınız
          </small>
          <div class="mt-2" *ngIf="!successStatus">
            <div>
              <form
                #newPassForm="ngForm"
                (ngSubmit)="
                  repassword.invalid || password.invalid
                    ? (showError = true)
                    : onSubmit()
                "
                novalidate
              >
                <div class="form-group row">
                  <label for="password"
                    >{{ "new_password" | translate }} *</label
                  >
                  <input
                    type="password"
                    name="password"
                    [(ngModel)]="new.password"
                    class="form-control form-control-sm"
                    (change)="changeErrorStatus()"
                    #password="ngModel"
                    id="password"
                    [ngClass]="
                      showError && password.invalid ? 'errorInput' : ''
                    "
                    required
                  />
                  <div
                    *ngIf="password.invalid && showError"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
                <div class="form-group row">
                  <label for="rePassword"
                    >{{ "new_password_confirmation" | translate }} *</label
                  >
                  <input
                    type="password"
                    name="repassword"
                    [(ngModel)]="new.confirm_password"
                    (change)="changeErrorStatus()"
                    class="form-control form-control-sm"
                    #repassword="ngModel"
                    id="rePassword"
                    [ngClass]="
                      showError && repassword.invalid ? 'errorInput' : ''
                    "
                    required
                  />
                  <div
                    *ngIf="repassword.invalid && showError"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
                <div
                  class="alert alert-danger row"
                  role="alert"
                  [hidden]="!passwordStatus"
                >
                  {{ "password_not_same" | translate }}
                </div>
                <div class="form-group row">
                  <button class="btn btn-block w-100 btn-kalemblue">
                    {{ "set_password" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-12" *ngIf="successStatus">
            <div class="success-message message">
              {{ "set_new_password_success_message" | translate }}
            </div>
            <a
              role="button"
              [routerLink]="['/auth/login']"
              class="btn btn-block btn-kalemblue m-k"
              >Kullanıcı Giriş Sayfasına Git</a
            >
          </div>
          <small
            >Başka konularda yardım isterseniz
            <a href="auth/login">KLMERP Destek</a> ile iletişime geçebilirsiniz.
          </small>
        </div>
        <div class="error-inner" *ngIf="!token">
          <div class="error-body">
            {{ "not_access_token_error" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
